function AnimationController(){
    this.className			= "AnimationController";
    this.debug				= false;
    this.glob				= "/**";
    this.debugging 			= false;
};
AnimationController.inheritsFrom( StandardController );
AnimationController.prototype.swap = function( onComplete ){
    if(!this.isSetup) {
        this.setup();
    }

    this.setupAnimations();

    return true;
}
AnimationController.prototype.setup = function( onComplete ){
    this.isSetup = true;

    // Elements
    this.$body 	  = $("body");
    this.$header  = this.$body.find('.js-site-header');

    //this.timeline = gsap.timeline();

    this.easings = {
        'custom-1': CustomEase.create("custom", "0.75 0.000, 0.25, 1.000")
    };
}
AnimationController.prototype.setupAnimations = function() {
    this.$main 	  = this.$body.find("main");
    this.$elements = this.$main.find('[data-to]');

    const animations = this.getMeta()?.animations;

    const elements = [];
    this.$elements.each((i, element) => {
        const e = {};
        e.element = element;
        e.$element = $(element);

        e.id = e.$element.attr("id");
        e.animate = {};

        const from = e.$element.attr("data-from") ? JSON.parse(e.$element.attr("data-from")) : false;
        const to = e.$element.attr("data-to") ? JSON.parse(e.$element.attr("data-to")) : {};
        const settings = e.$element.attr("data-settings") ? JSON.parse(e.$element.attr("data-settings")) : {};
        const trigger = e.$element.attr("data-trigger") ? JSON.parse(e.$element.attr("data-trigger")) : false;

        e.$element.removeAttr("data-from");
        e.$element.removeAttr("data-to");
        e.$element.removeAttr("data-settings");
        e.$element.removeAttr("data-trigger");

        if(settings) {
            // console.log("Ease", this.easings);
            settings.ease = this.easings[settings.ease] ?? settings.ease;
        }

        if(trigger) e.trigger = trigger;
        e.from = from ?? {};

        if(to) {
            e.to = {
                ...to,
                ...settings
            }
        }

        //e.animate.to = e.$element.attr("data-animate-to");

        elements.push(e);
    });

    if(animations) animations.forEach((a, i) => {
        const e = {};

        const containerSelector = a?.trigger?.selector ?? ".page";

        const container = document.querySelector(containerSelector);
        const element = container.querySelector(a.selector)

        // e.selector = container;
        e.element = element;
        e.$container = $(container);
        e.$element = $(element);

        e.id = e.$element.attr("id");

        if(a?.settings) {
            // console.log("Ease", this.easings);
            a.settings.ease = this.easings[a.settings.ease] ?? a.settings.ease;
        }

        if(a?.trigger) {
            e.trigger = {
                selector: container,
                start: "top 50%",
                end: "bottom 50%",
                scrub: false,
                toggleActions: "play play reverse reverse", //"play none none none",
                ...a?.trigger,
            }
        }

        e.from = a?.from ?? {};

        if(a?.to) {
            e.to = {
                ...a?.to,
                ...a?.settings
            }
        }

        elements.push(e);
    });

    // console.log(elements);
    this.elements = elements;
}
AnimationController.prototype.on = function() {
    this.animations = [];

    this.elements.forEach((e, i) => {
        const settings = {};

        if(e.trigger) {
            settings.scrollTrigger = {
                trigger: e.trigger.selector,
                start: e.trigger.start,
                end: e.trigger.end,
                markers: this.debugging,
                scrub: e.trigger.scrub,
                toggleActions: e.trigger.toggleActions,
                invalidateOnRefresh: true,
            }
        }

        const animation = gsap.timeline(settings);

        animation.fromTo(
            e.element,
            e.from,
            e.to
        );

        this.animations.push(animation);
    });

    // console.log(this.animations);
}
AnimationController.prototype.killAnimations = function(){
    this.animations.forEach(animation => {
       if(animation.scrollTrigger) animation.kill();
    });
    this.animations = []; // Reset the array
}
AnimationController.prototype.off = function(){
    this.killAnimations();
};
